// extracted by mini-css-extract-plugin
module.exports = {"container":"hostHome_container__UyTgf","box":"hostHome_box__3kS0n","box__innerBox":"hostHome_box__innerBox__2KZD7","displayNone":"hostHome_displayNone__2nx60"};